<template>
    <div>
        <v-container fluid class="fill-height max-h d-flex align-center justify-center">
            <h1 class="text-center mt-4">Olá, {{ this.auth.user.name }}! Que bom te ter de volta. <br> Selecione qual
                plataforma deseja acessar:</h1>
            <v-row justify="space-around" align="center" class="fill-height">
                <v-col cols="12" sm="5" md="4">
                    <v-card class="portal-card portal-card-hover elevation-8" height="415" :to="`/app/home`" hover>
                        <div class="card-border card-border-hover">
                            <v-card-text class="d-flex flex-column justify-center align-center h-100">
                                <div class="text-center">
                                    <h2 class="text-h4 font-weight-bold mb-2 card-text-hover">Gestão do seu veículo no</h2>

                                    <img style="height: 80px;" :src="logoCda" alt="Logo" class="card-logo-hover">
                                    <h3 color="white" style="color: white;" class="text-h5 text-white font-weight-bold card-text-hover">
                                        e</h3>
                                    <img style="height: 80px;" :src="logoCdm" alt="Logo" class="card-logo-hover">



                                </div>
                            </v-card-text>
                        </div>
                    </v-card>
                </v-col>

                <v-col cols="12" sm="5" md="4">
                    <v-card class="portal-card portal-card-hover elevation-8" :class="{ 'card-auth-disabled': !auth?.whitelabel?.w?.enabled }"
                        height="415" :to="auth?.whitelabel?.w?.enabled ? `/dashboard` : null"
                        :hover="auth?.whitelabel?.w?.enabled"
                        @click="!auth?.whitelabel?.w?.enabled && $event.preventDefault()">
                        <div class="card-border card-border-hover">
                            <v-card-text class="d-flex flex-column justify-center align-center h-100">
                                <div class="text-center">
                                    <h2 class="text-h4 font-weight-bold mb-2 card-text-hover">Gestão da sua loja de mídia</h2>

                                    <v-avatar class="my-5 card-avatar-hover" v-if="auth" width="78" height="78">
                                        <v-img :src="auth.profile.logo" alt="" width="78" contain />
                                    </v-avatar>
                                    <p class="text-subtitle-1 card-text-hover">
                                        {{ auth?.whitelabel?.w?.enabled ? this.auth.profile.name : '' }}

                                    </p>
                                </div>
                            </v-card-text>
                        </div>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import { getAuth } from '@/services/authService'
export default {
    name: 'PortalHub',
    data: () => ({
        logoCda: require('@/assets/cda-white.svg'),
        logoCdm: require('@/assets/cdm-white.svg'),
        get auth() {
            return getAuth()
        },
    }),

}
</script>

<style scoped>
.max-h {
    max-width: 1260px;
}

.portal-card {
    padding: 6px;
    cursor: pointer;
    transition: all .8s ease;
    border-radius: 16px;
    overflow: hidden;
    margin: 70px 0;
    width: 500px;
}
.portal-card-hover {
    background: linear-gradient(135deg, #e0e0e0 0%, #bdbdbd 100%) !important;
}

.portal-card-hover:hover {
    background: #233976 !important;
    transform: translateY(-8px);
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15) !important;
}

.card-text-hover {
    color: white !important;
    transition: color .8s ease;
}

.portal-card-hover:hover .card-text-hover {
    color: white !important;
}

.card-border-hover {
    border-color: rgba(158, 158, 158, 0.3) !important;
    background: rgba(158, 158, 158, 0.1) !important;
    transition: all .8s ease;
}

.portal-card-hover:hover .card-border-hover {
    border-color: rgba(255, 255, 255, 0.877) !important;
    background: transparent !important;
}

.card-auth-disabled {
    cursor: not-allowed !important;
}

.card-auth-disabled:hover {
    background: linear-gradient(135deg, #e0e0e0 0%, #bdbdbd 100%) !important;
    transform: none !important;
    box-shadow: none !important;
}

.card-auth-disabled:hover .card-text-hover {
    color: #9e9e9e !important;
}

.card-auth-disabled:hover .card-border-hover {

    border-color: rgba(158, 158, 158, 0.3) !important;
    background: rgba(158, 158, 158, 0.1) !important;
}

.portal-card .text-h4,
.portal-card .text-subtitle-1 {
    color: white !important;
}

.card-border {
    height: 100%;
    border: 3px solid rgba(255, 255, 255, 0.877);
    border-radius: 12px;
    position: relative;
    backdrop-filter: blur(10px);
}

.card-border::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 9px;
    border: 1px solid rgba(255, 255, 255, 0.5);
    pointer-events: none;
}

.fill-height {
    min-height: 60vh;
}

.v-card-text {
    padding: 24px !important;
    height: 100%;
}

.h-100 {
    height: 100%;
}
</style>